import MuiCheckbox, { CheckboxProps } from '@mui/material/Checkbox';
import CheckboxEmpty from '../../assets/icons/checkboxEmpty';
import CheckboxChecked from '../../assets/icons/checkboxChecked';
import CheckboxIndeterminate from '../../assets/icons/checkboxIndeterminate';
import palette from 'theme/palette';

interface IconProps {
  iconWidth: number;
  iconHeight: number;
}

export const Checkbox = ({ iconWidth, iconHeight, ...props }: CheckboxProps & Partial<IconProps>) => {
  return (
    <MuiCheckbox
      icon={
        <CheckboxEmpty
          width={iconWidth}
          height={iconHeight}
          color={props.disabled ? palette.button.secondary : palette.secondary.lighter}
        />
      }
      checkedIcon={<CheckboxChecked width={iconWidth} height={iconHeight} />}
      indeterminateIcon={<CheckboxIndeterminate width={iconWidth} height={iconHeight} />}
      checked={props.value as boolean}
      {...props}
    />
  );
};

export default Checkbox;
